import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelectedResult } from "../../../contexts/SelectedResultContext";
import {
  logOrgTourRouteLegacyRedirect,
  orgTourProfileDashboardPath,
} from "../../../utils/organizedTourRoutes";
import {
  readOrganizedTourDealId,
  readOrganizedTourDealSnapshot,
} from "../../../utils/resolveOrganizedTourDealFromContext";

/**
 * Legacy `/tour/profile` (no dealId) — redirect to dashboard profile when possible.
 */
export default function OrganizedTourLegacyProfileRedirect() {
  const location = useLocation();
  const { selectedResult } = useSelectedResult();
  let dealId = readOrganizedTourDealId(selectedResult);

  const fromSnapshot = (() => {
    try {
      for (let i = 0; i < sessionStorage.length; i++) {
        const k = sessionStorage.key(i);
        if (!k?.startsWith("orgTourDealSnapshot:")) continue;
        const id = k.slice("orgTourDealSnapshot:".length);
        const snap = readOrganizedTourDealSnapshot(id);
        if (snap) return readOrganizedTourDealId(snap);
      }
    } catch {
      /* ignore */
    }
    return null;
  })();

  const resolved = dealId || fromSnapshot;
  const to = resolved
    ? orgTourProfileDashboardPath(resolved)
    : "/p/dashboard/searchoffer";

  useEffect(() => {
    logOrgTourRouteLegacyRedirect(location.pathname, to, "public_tour_profile");
  }, [location.pathname, to]);

  return <Navigate to={to} replace />;
}
